module.exports = __webpack_public_path__ + "static/media/forth-image.68b9bb8a.png";